import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuthMode } from '@app/providers/authModeProvider'
import { ROUTES } from '@shared/constants/routes'
import { coachChatStore } from './coachChat.store'

export const CoachChatRuntime = () => {
	const location = useLocation()
	const { accessToken, authenticated, ensureFreshSession, initialized } = useAuthMode()
	const isChatVisible = location.pathname === ROUTES.overall.aiMessenger

	useEffect(() => {
		coachChatStore.configureAuth({
			accessToken,
			authenticated,
			ensureFreshSession,
			initialized,
		})
	}, [accessToken, authenticated, ensureFreshSession, initialized])

	useEffect(() => {
		coachChatStore.setVisible(isChatVisible)
		if (isChatVisible && initialized && authenticated) {
			void coachChatStore.loadInitial()
		}
	}, [authenticated, initialized, isChatVisible])

	useEffect(() => {
		if (typeof document === 'undefined') return undefined

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				void coachChatStore.reconcileLatest()
			}
		}

		document.addEventListener('visibilitychange', handleVisibilityChange)
		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange)
		}
	}, [])

	return null
}
